import React, { useState } from 'react'
import PropTypes from 'prop-types'
import 'styles/EditDeviceModal.css'
import { getOnChangeFunction } from 'utils'

const EditDeviceModal = ({ device, groups = [], onClose, onSave }) => {
  const [localDevice, setLocalDevice] = useState({ ...device })
  const onChange = getOnChangeFunction(setLocalDevice, localDevice)

  return (
    <div className='edit-device-modal-overlay'>
      <div className='edit-device-modal'>
        <h2>Update Device</h2>

        <div className='device-details-section'>
          <h3>Device Details</h3>

          <label className='flex flex-col gap-1 text-sm font-medium text-gray-700 mb-3'>
            Device Group
            <select
              name='deviceGroupId'
              value={localDevice.deviceGroupId || ''}
              onChange={onChange}
              className='p-2 border rounded-md shadow-sm bg-white font-normal w-full'
            >
              <option value=''>— No group —</option>
              {groups.map(group => (
                <option key={group.value} value={group.value}>{group.label}</option>
              ))}
            </select>
          </label>

          <div className='manager-checkbox'>
            <label>
              <input
                type='checkbox'
                name='managerDevice'
                checked={localDevice.managerDevice}
                onChange={onChange}
              />
              Manager Device
            </label>
          </div>
        </div>

        <div className='modal-actions'>
          <button type='button' className='cancel-button' onClick={onClose}>
            Cancel
          </button>
          <button type='button' className='save-button' onClick={() => onSave(localDevice)}>
            Save
          </button>
        </div>
      </div>
    </div>
  )
}

EditDeviceModal.propTypes = {
  device: PropTypes.object.isRequired,
  groups: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })),
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
}

export default EditDeviceModal
